import { render, staticRenderFns } from "./DownConfirm.vue?vue&type=template&id=2b89b264&scoped=true&"
import script from "./DownConfirm.vue?vue&type=script&lang=js&"
export * from "./DownConfirm.vue?vue&type=script&lang=js&"
import style0 from "./DownConfirm.vue?vue&type=style&index=0&id=2b89b264&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b89b264",
  null
  
)

export default component.exports